 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"analyst~home~industry~organization~stock":"analyst~home~industry~organization~stock","analyst~industry~organization":"analyst~industry~organization","analyst~organization~stock":"analyst~organization~stock","analyst":"analyst","organization":"organization","industry":"industry","stock":"stock","home":"home","reportDetail":"reportDetail","pdfjs-dist":"pdfjs-dist","pdfjsWorker":"pdfjsWorker"}[chunkId]||chunkId) + "." + {"analyst~home~industry~organization~stock":"d58906a1","analyst~industry~organization":"93805e17","analyst~organization~stock":"8df2e938","analyst":"29b6cc51","organization":"f296c528","industry":"af8f5649","stock":"10bbaeac","home":"ebaf4c17","chunk-53b13f87":"1b273eeb","chunk-1778f184":"9fd65d47","chunk-1d752afd":"59f283ca","chunk-2d0a464d":"292424bb","chunk-2d0a4993":"84e8cd55","chunk-2d0b2574":"2b07acc6","chunk-2d0b274b":"d1e017c0","chunk-2d0b2947":"59ce62a8","chunk-2d0ba138":"6845c95e","chunk-2d0bfe96":"04ed402f","chunk-2d0c779f":"a1f90591","chunk-2d0d9fd1":"32d9026c","chunk-2d0da7ad":"cc7ea322","chunk-2d0e48f9":"3ed84a52","chunk-2d0e95b6":"3f92d52d","chunk-2d0f00a0":"64cdb2af","chunk-2d0f1152":"e65a3984","chunk-2d20e7d5":"5d8215ba","chunk-2d2109cd":"71f14304","chunk-2d21368a":"aae33215","chunk-2d21de17":"e65efb5a","chunk-2d21f460":"9c256ecb","chunk-2d22894a":"09e2b1d7","chunk-2d22c33f":"507b2c91","chunk-2d230675":"48a6f28f","chunk-2f22fdf1":"eefcbf6c","chunk-505a2977":"f5157fb4","chunk-59c14710":"2982f30d","chunk-64d6fa27":"490e1fc7","chunk-6b00c34c":"e64563eb","chunk-72a1f2d8":"00dc5c2d","chunk-7652dadc":"4e467655","chunk-920b32b6":"4e92d676","chunk-92e6b450":"ab1dddd4","chunk-945b07e6":"2a23a3b2","chunk-c4844064":"02bce620","chunk-c4dc5c20":"4c5e6881","chunk-c74b96e8":"7f7a8814","chunk-d0617188":"b00e6339","chunk-da7fc4b2":"08e16575","chunk-e2480228":"6b500c95","chunk-f257ca08":"544083bc","reportDetail":"ae152118","chunk-2d0d6f2f":"61dc03b7","chunk-3ac2e8cd":"8e2fe000","chunk-2d0e5bfd":"404f14e7","pdfjs-dist":"d105ede0","pdfjsWorker":"76206af0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"analyst~home~industry~organization~stock":1,"analyst~industry~organization":1,"analyst~organization~stock":1,"analyst":1,"organization":1,"industry":1,"stock":1,"home":1,"chunk-53b13f87":1,"chunk-1778f184":1,"chunk-1d752afd":1,"chunk-2f22fdf1":1,"chunk-505a2977":1,"chunk-59c14710":1,"chunk-64d6fa27":1,"chunk-6b00c34c":1,"chunk-72a1f2d8":1,"chunk-7652dadc":1,"chunk-920b32b6":1,"chunk-92e6b450":1,"chunk-945b07e6":1,"chunk-c4844064":1,"chunk-c4dc5c20":1,"chunk-c74b96e8":1,"chunk-d0617188":1,"chunk-da7fc4b2":1,"chunk-e2480228":1,"chunk-f257ca08":1,"reportDetail":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"analyst~home~industry~organization~stock":"analyst~home~industry~organization~stock","analyst~industry~organization":"analyst~industry~organization","analyst~organization~stock":"analyst~organization~stock","analyst":"analyst","organization":"organization","industry":"industry","stock":"stock","home":"home","reportDetail":"reportDetail","pdfjs-dist":"pdfjs-dist","pdfjsWorker":"pdfjsWorker"}[chunkId]||chunkId) + "." + {"analyst~home~industry~organization~stock":"ceacedc5","analyst~industry~organization":"a43bef35","analyst~organization~stock":"c47954ad","analyst":"be78d338","organization":"bd87d515","industry":"fe805260","stock":"22dc3f7f","home":"807e8fae","chunk-53b13f87":"75d456e0","chunk-1778f184":"180db281","chunk-1d752afd":"f5b452a1","chunk-2d0a464d":"31d6cfe0","chunk-2d0a4993":"31d6cfe0","chunk-2d0b2574":"31d6cfe0","chunk-2d0b274b":"31d6cfe0","chunk-2d0b2947":"31d6cfe0","chunk-2d0ba138":"31d6cfe0","chunk-2d0bfe96":"31d6cfe0","chunk-2d0c779f":"31d6cfe0","chunk-2d0d9fd1":"31d6cfe0","chunk-2d0da7ad":"31d6cfe0","chunk-2d0e48f9":"31d6cfe0","chunk-2d0e95b6":"31d6cfe0","chunk-2d0f00a0":"31d6cfe0","chunk-2d0f1152":"31d6cfe0","chunk-2d20e7d5":"31d6cfe0","chunk-2d2109cd":"31d6cfe0","chunk-2d21368a":"31d6cfe0","chunk-2d21de17":"31d6cfe0","chunk-2d21f460":"31d6cfe0","chunk-2d22894a":"31d6cfe0","chunk-2d22c33f":"31d6cfe0","chunk-2d230675":"31d6cfe0","chunk-2f22fdf1":"a5a6b0b6","chunk-505a2977":"d6cb831f","chunk-59c14710":"ca199e9c","chunk-64d6fa27":"50be8b56","chunk-6b00c34c":"1c8f1f67","chunk-72a1f2d8":"67b357e0","chunk-7652dadc":"f2409f93","chunk-920b32b6":"98bcff71","chunk-92e6b450":"caf7b12f","chunk-945b07e6":"be3174ca","chunk-c4844064":"fc0a5b8b","chunk-c4dc5c20":"9660f651","chunk-c74b96e8":"d34ad48b","chunk-d0617188":"444ea73b","chunk-da7fc4b2":"1cd9823c","chunk-e2480228":"63a69d2a","chunk-f257ca08":"9a0c4128","reportDetail":"657b94b3","chunk-2d0d6f2f":"31d6cfe0","chunk-3ac2e8cd":"31d6cfe0","chunk-2d0e5bfd":"31d6cfe0","pdfjs-dist":"31d6cfe0","pdfjsWorker":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
